import { useEffect, useState } from "react";

/** Debounce a value — useful for server-side search inputs. */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => { setDebounced(value); }, delayMs);
    return () => { window.clearTimeout(timer); };
  }, [value, delayMs]);

  return debounced;
}
